@if (isLoading) {
<div class="panel-dummy margin-above">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<form class="form-container margin-above" [formGroup]="formGroupStoreDetails">
  <app-input formControlName="storeName"
    label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.StoreName' | translate }}"></app-input>

  <ng-container>
    <app-input formControlName="name"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.ManagerName' | translate }}"></app-input>

    <app-input type="tel" formControlName="phone"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.PhoneNumber' | translate }}">
    </app-input>

    <app-input type="email" formControlName="email"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.Email' | translate }}">
    </app-input>

    @if (!readOnly) {
    <p class="p-formfield-info">{{ 'Modules.XPACManagementComponent.StoreInfoComponent.EmailInfo' | translate }}</p>
    }
  </ng-container>

  <ng-container>
    @if (!readOnly) {
    <app-address-search (address)="onAddressSearched($event)"
      [disabled]="!hasUpdatePermission('Store_Address')"></app-address-search>
    }

    <app-input formControlName="street"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.Street' | translate }}"></app-input>

    <app-input formControlName="streetNumber"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.StreetNumber' | translate }}">
    </app-input>

    <app-input formControlName="zipCode"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.ZipCode' | translate }}"></app-input>

    <app-input formControlName="city"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.City' | translate }}"></app-input>

    <app-input formControlName="state"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.StateCounty' | translate }}"></app-input>

    <app-input type="options" [basicOptions]="countries" basicTranslateKey="Countries" formControlName="country"
      label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.Country' | translate }}"></app-input>
  </ng-container>

  <app-input formControlName="storeId"
    label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.StoreID' | translate }}"></app-input>

  <app-input formControlName="retailerId"
    label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.RetailerID' | translate }}"></app-input>

  <app-input formControlName="groupId"
    label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.GroupID' | translate }}"></app-input>

  <app-input formControlName="regionId"
    label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.RegionID' | translate }}"></app-input>

  <app-input formControlName="customId"
    label="{{ 'Modules.XPACManagementComponent.StoreInfoComponent.CustomID' | translate }}"></app-input>
</form>
}
